module.exports = __webpack_public_path__ + "static/schedule-b0ab87e2c70424b162e9854eaac1c881.png";